import { ReactNode } from "react";
import { Route, Routes, useParams, Link } from "react-router-dom";

import Login from "../pages/Login";
import IntlWrapper from "../pages/IntlWrapper";
import Home from "../pages/Home";
import ProjectDetail from "../pages/ProjectDetail";
import AuthenticatedGuard from "./AuthenticatedGuard";
import langs from "../locales/SCQuick3DDict.json";
import i18n from "../locales/i18n";
import Upload from "../pages/Upload";
import { EDisplayType } from "../components/ProjectDetail/Interfaces/ProjectDetailInterfaces";
import { config } from "../config/config";
import ProjectARView from "../pages/ProjectARView";

export const UserRouter = () => {
  const url = new URL(window.location.href);
  const urlPathname = url.pathname.substring(1);

  return (
    <Routes>
      <Route path="/login" element={<Login urlProjectId={urlPathname} />} />
      <Route
        path="/"
        element={
          <AuthenticatedGuard path="/">
            <IntlWrapper usingUserSiteContext={true}>
              <Home />
            </IntlWrapper>
          </AuthenticatedGuard>
        }
      />
      <Route
        path="/:projectId"
        element={
          <AuthenticatedGuard path="/:projectId">
            <IntlWrapper usingUserSiteContext={true}>
              <ProjectDetail displayType={EDisplayType.Web} />
            </IntlWrapper>
          </AuthenticatedGuard>
        }
      />
      <Route
        path="/ios/:lang/:projectId"
        element={
          <AuthenticatedGuard path="/ios/:lang/:projectId">
            <IntlWrapper usingUserSiteContext={false}>
              <LangWrap>
                <ProjectDetail displayType={EDisplayType.iOS} />
              </LangWrap>
            </IntlWrapper>
          </AuthenticatedGuard>
        }
      />
      <Route
        path="/ar/:projectId"
        element={
          <AuthenticatedGuard path="/ar/:projectId">
            <IntlWrapper usingUserSiteContext={true}>
              <ProjectARView />
            </IntlWrapper>
          </AuthenticatedGuard>
        }
      />
      <Route
        path="/ios-ar/:lang/:projectId"
        element={
          <AuthenticatedGuard path="/ios-ar/:lang/:projectId">
            <IntlWrapper usingUserSiteContext={false}>
              <LangWrap>
                <ProjectARView />
              </LangWrap>
            </IntlWrapper>
          </AuthenticatedGuard>
        }
      />
      {config.debugMode ? (
        <Route path="/debug/upload" element={<Upload />} />
      ) : (
        ""
      )}
      <Route
        path="*"
        element={
          <div>
            <h2
              style={{ color: "white", textAlign: "center", marginTop: "20px" }}
            >
              404 Not Found
            </h2>
            <p style={{ color: "white", textAlign: "center" }}>
              <Link to="/">TOPへ戻る</Link>
            </p>
          </div>
        }
      />
    </Routes>
  );
};

type LangProps = {
  children: ReactNode;
};

const LangWrap = (props: LangProps) => {
  const { lang } = useParams();
  if (lang && Object.keys(langs).some((l) => l === lang)) {
    if (lang !== i18n.language) {
      // change to selected Language
      i18n.changeLanguage(lang);
    }

    return <>{props.children}</>;
  } else {
    return (
      <h4 style={{ color: "red" }}>
        The Language your selected is not supported.
      </h4>
    );
  }
};

export default UserRouter;
